module.exports = {
    "dashboard": "Papan Pemuka ",
    "myAccounts": "Akaun Saya ",
    "internationalTransfer": "Pemindahan Antarabangsa",
    "fundingType": "Jenis Pembiayaan",
    "deposit": "Simpanan ",
    "withdraw": "Mengeluarkan  ",
    "invoice": "Invois ",
    "requestMoney": "Pemintaan Wang ",
    "recipients": "Penerima ",
    "developers": "Pemaju",
    "myProfile": "Profil saya",
    "logout": "Log keluar",
    "qucikBooks": "QuickBooks",
    "profileDetails": "Butiran Profil",
    "password": "Kata Laluan ",
    "users": "Pengguna ",
    "qbDownloads": "Pemuat Turun QB ",
    "transfer": "Pemindahan",
    "allTransactions": "Semua Urus Niaga",
    "recurringTrans": "Transaksi Berulang",
    "firstName": "Name Pertama",
    "lastName": "Nama Keluarga ",
    "emailAddress": "Alamat E-Mel",
    "userRole": "Peranan Pengguna ",
    "settings": "Tetapan ",
    "oldPass": "Kata Laluan Lama ",
    "newPass": "Kata Laluan Baharu ",
    "confirmPass": "Sahkan Kata Laluan",
    "passwordRequirements": "Keperluan Kata Laluan",
    "reqOne": "Sekurang-kurangnya 8 aksara",
    "reqTwo": "Sekurang-kurangnya satu huruf kecil",
    "reqThree": "Sekurang-kurangnya satu huruf besar",
    "reqFour": "Sekurang-kurangnya satu nombor",
    "reqFive": "Sekurang-kurangnya satu aksara berlainan ",
    "reqSix": "Sekurang-kurangnya satu aksara berlainan ",
    "reqSeven": "Tiada Ruang ",
    "saveChanges": "Simpan Perubahan",
    "onlyIntAccounts": "Hanya Akaun Antarabangsa",
    "availableBalance": "Baki yang ada ",
    "currentBalance": "Baki terkini",
    "lastUpdatedDate": "Tarikh Kemas Kini Terakhir",
    "channel": "Saluran ",
    "webhook": "Webhook ",
    "recipientName": "Nama Penerima ",
    "aCHAccountNumber": "Nombor Akaun ACH",
    "wireAccountNumber": "Nombor Akaun Wire",
    "aPIKey": "Kunci API",
    "clientName": "Nama Pelanggan ",
    "createdBy": "Dihasilkan Oleh ",
    "transactionID": "ID Transaksi",
    "sourceType": "Jenis sumber",
    "accountReference": "Rujukan Akaun",
    "routingReference": "Rujukan Penghalaan",
    "expiryDate": "Tarikh luput",
    "recipientEmail": "E-Mel Penerima ",
    "creationDate": "Tarikh Penciptaan",
    "startDate": "Tarikh Pemulaan ",
    "reference": "Rujukan ",
    "transactionType": "Jenis Transaksi",
    "name": "Nama",
    "phone": "Nombor Telefon",
    "role": "Peranan",
    "complete": "Lengkap",
    "failure": "Gagal",
    "returns": "Pemulangan ",
    "count": "Kiraan ",
    "accounts": "Akaun ",
    "noAccounts": "Tiada Akaun ",
    "transactionsType": "Jenis Transaksi",
    "mostRecentTransactions": "Transaksi Terkini",
    "export": "eksport",
    "transactionHistory": "sejarah transaksi",
    "transactionReference": "Rujukan Transaksi",
    "parentReference": "Rujukan Ibu Bapa",
    "paymentReference": "Rujukan pembayaran",
    "amount": "Jumlah ",
    "invoiceNumber": "Nombor invois",
    "orderName": "Nama Pesanan",
    "feeAmount": "Jumlah Yuran",
    "reversalFee": "Yuran Pemulangan",
    "taxAmount": "Jumlah cukai",
    "exciseTax": "Cukai Eksais",
    "salesTax": "Cukai jualan",
    "registrationFee": "Yuran pendaftaran",
    "serviceFee": "Bayaran perkhidmatan",
    "conversionRate": "Kadar penukaran",
    "oFACMatch": "Padanan OFAC",
    "type": "Jenis ",
    "recurringReference": "Rujukan Berulang",
    "status": "Status",
    "created": "Dicipta",
    "account": "Akaun ",
    "receiver": "Penerima ",
    "description": "Penerangan ",
    "paymentType": "Jenis pembayaran",
    "from": "Daripada",
    "sendVia": "Hantar Melalui",
    "recipientEmailAddress": "Alamat E-mel Penerima",
    "recipientPhoneNumber": "Nombor Telefon Penerima",
    "recipientAccountNumber": "Nombor Akaun Penerima",
    "confirmAccountNumber": "Sahkan Nombor Akaun",
    "to": "Kepada",
    "currency": "Mata Wang ",
    "direction": "Arah",
    "paymentDate": "Tarikh pembayaran",
    "service": "Perkhidmatan",
    "frequency": "Kekerapan",
    "endDate": "Tarikh Akhir",
    "numberofTransfers": "Bilangan Pemindahan",
    "internalDescription": "Penerangan Dalaman",
    "accountNumber": "Nombor Akaun ",
    "pc_accountNumber": "Nombor Akaun ",
    "fileName": "Nama fail",
    "recipient_email": "E-Mel Penerima ",
    "createdDate": "Tarikh Dicipta",
    "dueDate": "Tarikh tamat tempoh",
    "memo": "Memo",
    "action": "Tindakan",
    "email": "E-Mel",
    "phoneNumber": "Nombor Telefon",
    "bankName": "Name Bank ",
    "recipientType": "Jenis Penerima ",
    "fromAccountNumber": "Daripada Nombor Akaun",
    "nameonCard": "Nama pada kad",
    "zipCode": "Poskod ",
    "accountName": "Nama Akaun ",
    "routingNumber": "Nombor Penghalaan",
    "accountType": "Jenis Akaun ",
    "address": "Alamat ",
    "city": "Bandar ",
    "country": "Negara",
    "state": "Negeri",
    "verificationType": "Jenis Pengesahan",
    "debitAmount": "Jumlah Debit",
    "firstCreditAmount": "Jumlah Kredit Pertama",
    "secondCreditAmount": "Jumlah Kredit Kedua",
    "nickName": "Nama Samaran",
    "beneficiaryBankCode": "Kod Bank Penerima",
    "addressLine1": "Alamat Baris 1",
    "addressLine2": "Alamat Baris 2",
    "paymentMethod": "Kaedah Pembayaran",
    "referenceID": "ID Rujukan",
    "aCHDetails": "Butiran ACH",
    "wireDetails": "Butiran Wayar",
    "internationalTransferDetails": "Butiran Pemindahan Antarabangsa",
    "selectDate": "Pilih Tarikh",
    "sender": "penghantar",
    "remarks": "Penyata ",
    "buyorSell": "Beli atau Jual ",
    "toAccountNumber": "Kepada Nombor Akaun ",
    "paymentInstrument": "Alat Pembayaran ",
    "fromaccount": "Daripada Akaun ",
    "toCounterparty": "Kepada Rakan Niaga",
    "purposeofPayment": "Tujuan Pembayaran",
    "fXRate": "Kadar FX",
    "fXAmount": "Jumlah FX ",
    "fXCurrency": "Mata Wang FX ",
    "toName": "Kepada Nama ",
    "toAccount": "Kepada Akaun ",
    "nextTransactionDate": "Tarikh Urus Niaga Seterusnya",
    "aPICode": "Kod API",
    "publicKey": "Kunci Awam",
    "privateKey": "Kunci Peribadi",
    "optional": "Pilihan ",
    "additionalInformation": "Maklumat tambahan",
    "createPayment": "Buat Pembayaran",
    "downloadPDF": "Download PDF",
    "resend": "Hantar semula",
    "approve": "Terima",
    "decline": "Ditolak",
    "addCard": "Tambah Kad ",
    "addBankAccount": "Tambah Akaun Bank ",
    "addNewRecipient": "Tambah Penerima Baharu ",
    "synchronizeQuickBooks": "segerakkan QuickBooks",
    "create": "Cipta",
    "newUser": "Pengguna Baru ",
    "generate": "Menjana",
    "wITHDRAW": "Mengeluarkan  ",
    "confirm": "Sahkan ",
    "cancel": "Batal",
    "close": "Tutup",
    "sendResetInstructions": "Hantar Arahan Set Semula",
    "logIn": "Log Masuk ",
    "resetPassword": "Menetapkan semula kata laluan",
    "setPassword": "Tetapkan kata laluan",
    "signUp": "Daftar",
    "forgotPassword": "Lupa kata laluan",
    "backToLogin": "Kembali untuk log masuk",
    "enterOtp": "Masukkan Kod Pengesahan",
    "resendCode": "Hantar kod baharu",
    "selectPayment": "Pilih Jenis Pembayaran",
    "scheduleRecurringTransaction": "Jadualkan Transaksi Berulang",
    "forgotPassText": "Masukkan e-mel yang dikaitkan dengan akaun anda dan kami akan menghantar e-mel dengan arahan untuk menetapkan semula kata laluan anda.",
    "unableToCP": "Tidak dapat membuat pembayaran",
    "plsSelectPaymentTyp": "Sila pilih jenis pembayaran",
    "plsSelectFromAcc": "Sila pilih daripada akaun",
    "selectPaymentPayment": "Sila pilih jenis pembayaran",
    "enterEmail": "Sila masukkan Alamat E-mel.",
    "emailValidation": "Alamat E-mel tidak boleh melebihi 320 Aksara",
    "enterPhone": "Sila masukkan nombor telefon yang sah",
    "enterAccNum": "Sila masukkan Nombor Akaun",
    "AccNum": "Sila masukkan Nombor Akaun",
    "selectRecipientName": "Sila pilih nama penerima",
    "enterAmounttoTransfer": "Sila masukkan jumlah untuk dipindahkan",
    "enterCurrency": "Sila masukkan mata wang untuk dipindahkan ",
    "selectDirection": "Sila pilih tuju arah",
    "selectPaymentDate": "Sila pilih tarikh pembayaran",
    "selectPaymentdate": "Sila pilih tarikh pembayaran",
    "selectServiceType": "Sila pilih jenis perkhidmatan ",
    "selectFrequency": "Sila pilih kekerapan ",
    "enterAmount": "Sila masukkan jumlah ",
    "selectTxnDate": "Sila masukkan tarikh urus niaga ",
    "selectRecipientType": "Sila pilih jenis penerima",
    "enterEmailAddress": "Sila masukkan Alamat E-mel",
    "validEmail": "Sila masukkan alamat E-mel yang sah",
    "EmailValidation": "Alamat E-mel tidak boleh melebihi 320 Aksara",
    "selectFrmAcc": "Sila pilih daripada akaun",
    "invoiceAlpha": "Nombor invois haruslah dalam bentuk abjad angka",
    "enterInvoiceNum": "Sila masukkan Nombor Invois",
    "invoiceValidation": "Nombor Invois tidak boleh melebihi 150 Aksara",
    "amountToTransfer": "PSila masukkan jumlah yang hendak dipindahkan",
    "valueForMemo": "Sila masukkan nilai untuk Memo",
    "memoValidation": "Memo tidak boleh melebihi 255 Aksara",
    "selectPaymentType": "Please select the payment type",
    "enterName": "Sila masukkan nama",
    "ValidName": "Sila masukkan nama yang sah",
    "nameValidation": "Nama tidak boleh kurang daripada 3 aksara",
    "Name": "Sila masukkan nama",
    "validname": "Sila masukkan nama yang sah",
    "nameValid": "Nama tidak boleh kurang daripada 3 aksara",
    "enterZipCode": "Sila masukkan kod pos",
    "validZipCode": "Sila masukkan poskod yang sah",
    "validzipcode": "Poskod tidak boleh kurang daripada 5 digit",
    "validAccName": "Sila masukkan Nama Akaun",
    "enterValidAccName": "Sila masukkan nama Akaun yang sah",
    "maxAccName": "Nama akaun tidak boleh melebihi 20 digit",
    "minAccName": "Nama akaun tidak boleh kurang daripada 4 digit",
    "accNum": "Please enter the Account Number",
    "validAccNum": "Sila masukkan Nombor Akaun yang sah",
    "maxAccNum": "Nombor akaun tidak boleh melebihi 20 digit",
    "japanMaxAccNum": "Nombor akaun tidak boleh melebihi 35 digit.",
    "japanMaxBankName": "Nama Bank tidak boleh melebihi 35 digit.",
    "japanMinSwiftCode": "Kod Swift hendaklah sekurang-kurangnya 8 aksara",
    "japanMinAddress": "Alamat tidak boleh kurang daripada 2 Aksara",
    "japanMaxCity": "Bandar tidak boleh lebih daripada 35 Aksara.",
    "minAccNum": "Nombor akaun tidak boleh kurang daripada 4 digit",
    "routingNum": "Please enter the Routing Number",
    "validRoutingNum": "Sila masukkan Nombor Penghalaan yang sah",
    "minRoutingNum": "Routing number cannot be less than 9 digits",
    "ValidRoutingNum": "Sila masukkan Nombor Penghalaan yang sah",
    "Acctype": "Sila pilih Jenis Akaun",
    "validAddress": "Sila masukkan alamat yang sah",
    "maxAddress": "Alamat tidak boleh melebihi 400 Aksara",
    "minAddress": "Alamat tidak boleh kurang daripada 5 Aksara",
    "City": "Sila masukkan nama bandar anda.",
    "maxCity": "Nama Bandar tidak boleh melebihi 60 Aksara",
    "countryName": "Sila Pilih Nama Negara",
    "stateName": "Sila Pilih Nama Negeri",
    "validzipCode": "Please enter a valid Zip Code",
    "selectVerificationType": "Sila pilih Jenis Pengesahan",
    "debitAmnt": "Sila masukkan jumlah debit",
    "creditAmnt": "Sila masukkan jumlah kredit",
    "CreditAmount": "Sila masukkan jumlah kredit",
    "AccName": "Sila masukkan Nama Akaun",
    "recipienttype": "Sila pilih jenis penerima",
    "accNumber": "Sila masukkan Nombor Akaun",
    "validAccnum": "Sila masukkan Nombor Akaun yang sah",
    "maxAccNumber": "Account number cannot be more than 20 digits",
    "minAccNumber": "Nombor akaun tidak boleh kurang daripada 4 digit",
    "beneficiaryBankcode": "Sila masukkan Kod Bank Penerima",
    "minRoutingNumber": "Nombor penghalaan tidak boleh kurang daripada 9 digit",
    "acountNumber": "Sila masukkan Nombor Akaun",
    "maxAccnum": "Nombor akaun tidak boleh melebihi 20 digit",
    "minAccnum": "Nombor akaun tidak boleh kurang daripada 4 digit",
    "routingnum": "Sila masukkan Nombor Penghalaan",
    "maxRoutingnum": "Nombor penghalaan tidak boleh kurang daripada 9 digit",
    "acctype": "Sila pilih Jenis Akaun",
    "accountNum": "Sila masukkan Nombor Akaun",
    "validaccountNum": "Sila masukkan Nombor Akaun yang sah",
    "maxAccountNum": "Nombor akaun tidak boleh melebihi 20 digit",
    "minAccountNum": "Nombor akaun tidak boleh kurang daripada 4 digit",
    "enterRoutingNum": "Please enter the Routing Number.",
    "minRouting": "Nombor penghalaan tidak boleh kurang daripada 9 digit",
    "enterAddressLine1": "Sila masukkan Alamat Baris 1",
    "maxAddrss": "Alamat tidak boleh melebihi 100 Aksara.",
    "minAddrss": "Alamat tidak boleh kurang daripada 5 Aksara",
    "enterCity": "Sila masuk nama Bandar",
    "selectCountryName": "Sila Pilih Nama Negara",
    "selectStateName": "Sila Pilih Nama Negeri",
    "validZipcode": "Sila masukkan Poskod yang sah",
    "valdAccnum": "Sila masukkan Nombor Akaun yang sah",
    "countryname": "Sila Pilih Nama Negara",
    "statename": "Sila Masukkan Nama Negeri yang Sah",
    "selectpaymentMethod": "Sila Pilih kaedah Pembayaran",
    "validPhone": "Sila masukkan nombor telefon yang sah",
    "inpFname": "Sila masukkan nama pertama anda",
    "inpLname": "Sila masukkan nama keluarga anda",
    "inpEmail": "Sila masukkan e-mel anda",
    "valiemail": "Sila masukkan e-mel yang sah",
    "validFname": "Sila masukkan nama pertama yang sah",
    "maxFname": "Nama Pertama tidak boleh melebihi 50 Aksara",
    "minFname": "Minimum 3 aksara diperlukan",
    "validLname": "Sila masukkan nama keluarga yang sah",
    "maxLname": "Nama keluarga tidak boleh melebihi 50 Aksara",
    "minLname": "Minimum 3 aksara diperlukan",
    "phoneNum": "Sila masukkan nombor telefon",
    "validPhoneNum": "Sila masukkan nombor telefon yang sah",
    "maxPhone": "Nombor telefon tidak boleh melebihi 10 digit",
    "minPhone": "Nombor telefon mestilah 10 digit.",
    "fromAcc": "Sila pilih daripada akaun",
    "selectstartDate": "Sila pilih tarikh mula",
    "newPsw": "Kata Laluan Baharu Disimpan",
    "unablePsw": "Tidak dapat mengemas kini Kata Laluan",
    "inpOldPsw": "Sila masukkan kata laluan lama anda",
    "inpNewPsw": "Sila masukkan kata laluan baharu anda",
    "maxPsw": "Kata laluan mestilah lebih panjang daripada 8 aksara",
    "newPassword": "Sila sahkan kata laluan baharu anda",
    "result": "Hasil ",
    "buyOrsell": "Sila pilih Beli atau Jual",
    "frmAccNum": "Sila pilih daripada nombor akaun",
    "selectaccNum": "Sila pilih ke nombor akaun",
    "paymentInst": "Sila pilih alat pembayaran",
    "instType": "Sila pilih jenis alat ",
    "insufficientFunds": "Kekurangan dana",
    "unablePayment": "Tidak dapat membuat pembayaran",
    "selectfundingType": "Sila pilih Jenis Pembiayaan",
    "amntTrans": "Sila masukkan jumlah untuk dipindahkan",
    "counterParty": "Sila pilih rakan niaga",
    "purposePayment": "Sila pilih tujuan pembayaran",
    "toAcc": "Sila pilih ke akaun",
    "validUrl": "Sila masukkan Url yang sah",
    "all": "Semua",
    "loading": "Memuatkan…",
    "transactions": "Transaksi",
    "noAccountData": "Tiada Data Akaun",
    "creditTransfer": "Pemindahan kredit",
    "noTransactionData": "Tiada Data Transaksi",
    "productCredit": "Kredit Produk",
    "refresh": "Segarkan semula",
    "UWallets": "Uwallet",
    "UWalletNumber": "Nombor Uwallet",
    "CreditID": "ID kredit",
    "InstrumentType": "Jenis Instrumen",
    "SelectCurrency": "Pilih Mata Wang",
    "select": "Pilih",
    "CardType": "Jenis kad",
    "pleaseselecttheCardtype": "Sila pilih jenis Kad",
    "CardNumber": "Nombor kad",
    "ExpirationDate": "Tarikh luput",
    "CVV": "CVV",
    "validCardNumber": "Sila masukkan Nombor Kad yang sah",
    "failedAddCard": "Gagal menambah kad",
    "cardAddedSuccessfully": "Kad berjaya ditambahkan",
    "validExpiration": "Sila masukkan Tarikh Tamat Tempoh yang sah",
    "validCVV": "Sila masukkan Kod CVV yang sah",
    "GoBack": "Pergi balik",
    "Confirmation": "Pengesahan",
    "NoPaymentInstrumentData": "Tiada Instrumen Pembayaran Ditemui",
    "deactivatePayment": "Adakah anda ingin menyahaktifkan Instrumen Pembayaran yang dipilih?",
    "accountVerified": "Berjaya!! Butiran akaun berjaya disahkan !!",
    "accountNotVerified": "Maaf!! Butiran akaun tidak dapat disahkan.",
    "validAmount": "Sila masukkan jumlah yang sah",
    "noConnectorFound": "Tiada Penyambung tersedia",
    "noCountryFound": "Tiada Senarai Negara ditemui",
    "wentWrongText": "Sesuatu telah berlaku!",
    "noStateFound": "Tiada Senarai Negeri ditemui",
    "noteText": "Nota: Pengesahan Akaun Bank menggunakan proses Deposit Cabaran akan mengambil masa sehingga 5 hari Bekerja",
    "accountalreadyExists": "Nombor akaun sudah wujud",
    "FeatureType": "Jenis Ciri",
    "validFeatureType": "Sila pilih Jenis Ciri.",
    "NoPaymentChannel": "Tiada Saluran Pembayaran Ditemui",
    "bankAddedsuccess": "Akaun bank berjaya ditambahkan",
    "bankAddedFailed": "Gagal menambah akaun bank",
    "limitBreach": "Pelanggaran Had",
    "withdrawMethodSelect": "Pilih Kaedah Tarik Balik",
    "totalAmount": "Jumlah keseluruhan",
    "decimalpointErr": "Maksimum 7 digit diterima sebelum titik perpuluhan.",
    "termsandCondition": "Harus menerima terma dan syarat.",
    "agreeText": "Saya bersetuju dengan",
    "termsText": "terma dan syarat.",
    "minAmountTextAch": "Jumlah pengeluaran Min ialah ",
    "withdrawFeeText1": "Yuran pengeluaran sebanyak ",
    "withdrawFeeText2": " akan dikenakan.",
    "maxAmountWithdrawTxt1": "Jumlah pengeluaran maksimum ialah ",
    "maxAmountWithdrawTxt2": " setiap permintaan.",
    "withdrawSuccess": "Pengeluaran Berjaya!",
    "createAnotherPay": "Buat Bayaran Lain",
    "selectCurrency": "Sila pilih Mata Wang",
    "lowPayquickerBalance": "Baki bayar cepat anda terlalu rendah untuk membuat pembayaran",
    "SelectPaymentMethod": "Pilih Kaedah Pembayaran",
    "availablePayBalance": "Baki Payquicker Tersedia",
    "fundsLoadedSuccess": "Dana berjaya dimuatkan!",
    "invalidAccDetails": "Butiran Akaun Tidak Sah",
    "insufficientAccBalance": "Baki Akaun Tidak Mencukupi",
    "invalidRecuDate": "Tarikh Berulang Tidak Sah Dipilih",
    "invalidTONum": "Tidak Sah Pada Nombor Akaun",
    "invalidTrans": "Transaksi Tidak Sah",
    "counterPartyNotFound": "CounterParty tidak ditemui",
    "ofacFailed": "Semakan OFAC gagal",
    "interSORFail": "Urus niaga antara SOR tidak dibenarkan",
    "invalidRoutingNum": "Nombor penghalaan tidak sah",
    "requestedServiceNotAvail": "Pada masa ini perkhidmatan yang diminta tidak tersedia",
    "limitExceedGlobal": "Had global melebihi",
    "clientLimitExceed": "Had transaksi pelanggan melebihi had",
    "dailyLimitExceed": "Had transaksi harian melebihi",
    "invalidRecdetails": "Butiran penerima tidak sah",
    "unabletoQuote": "Tidak dapat sebut harga",
    "enterRecipntPhone": "Masukkan Nombor Telefon Penerima",
    "enterAccNumber": "Masukkan Nombor Akaun Penerima",
    "accountNotMatch": "Nombor Akaun tidak sepadan",
    "recipientAccount": "Akaun Penerima",
    "convertedAmount": "Jumlah Tertukar",
    "paymentSuccess": "Pembayaran Berjaya Dibuat!",
    "orderNumber": "Nombor Pesanan",
    "showing": "Menunjukkan",
    "of": "daripada",
    "refNumber": "Nombor rujukan",
    "details": "Butiran",
    "NoTransactionsFound": "Tiada Transaksi ditemui",
    "conntedTOQB": "Berjaya disambungkan ke QuickBooks",
    "QuoteConvertedAmount": "Jumlah Amaun Tertukar Sebut Harga",
    "QBConnectFailed": "Gagal menyambung ke QuickBooks",
    "conenctingToQB": "Menyambung ke QuickBooks, Sila tunggu…",
    "synchronizeFailed": "Gagal menyegerakkan QuickBooks",
    "synchronizeSuccess": "Berjaya menyegerakkan QuickBooks",
    "syncQBText": "Kekal Segerak dengan QuickBooks Dalam Talian",
    "accountConnectedToQB": "Akaun sudah disambungkan ke QuickBooks",
    "Password": "Kata laluan",
    "profileChangesSaved": "Perubahan profil anda telah disimpan",
    "Timezone": "Zon masa",
    "Locale": "Tempatan",
    "passwordUpdateSuccess": "Perubahan Kata Laluan anda telah berjaya disimpan",
    "passwordReqText": "Kata laluan mesti mengikut keperluan yang ditetapkan",
    "passwordNotMatch": "Dua kata laluan yang anda masukkan tidak sepadan",
    "newUserSuccess": "Pengguna baharu berjaya dibuat",
    "addNewUser": "Tambah Pengguna Baharu",
    "ssoReq": "SSO Diperlukan",
    "logoutTxt": "Berjaya log keluar",
    "updatePaymentSuccess": "Berjaya! telah berjaya dikemas kini Instrumen Pembayaran",
    "updatePaymentFailed": "Gagal mengemas kini Instrumen Pembayaran",
    "noDataFound": "Tiada data dijumpai",
    "submit": "Hantar",
    "completed": "Selesai",
    "failed": "Gagal",
    "pending": "Yang belum selesai",
    "sent": "hantar",
    "SessionExpired": "Sesi Tamat",
    "Uwallet": "Uwallet",
    "UWalletfunding": "Pembiayaan dompet U",
    "debit": "Debit",
    "credit": "Kredit",
    "CARD": "Kad",
    "BANK": "Bank",
    "DIRECT_DEBIT": "Debit Terus",
    "active": "Aktif",
    "ccintl": "Kad Kredit Antarabangsa",
    "amex_dis": "Amex/Discover",
    "amex_card_text": "Tambah Kad AMEX",
    "nodata": "Tiada data",
    "note": "Nota",
    "load_fund_via_card": "Muatkan dana melalui kad",
    "load_fund_via_ach": "Muatkan dana melalui ACH",
    "load_fund_via_connector": "Muatkan dana melalui penyambung",
    "p2m_via_connector": "P2M melalui penyambung",
    "creditAdjustment": "Pelarasan Kredit",
    "debitAdjustment": "Pelarasan Debit",
    "startDateText": "Tarikh mula",
    "endDateText": "Tarikh tamat",
    "payIn": "Verify",
    "payOut": "Pembayaran",
    "checking": "Menyemak",
    "saving": "Menyimpan",
    "verify": "Sahkan",
    "reset": "Tetapkan semula",
    "today": "Hari ini",
    "a2a_reversal": "Pembalikan A2A",
    "credit_point": "Mata Kredit",
    "commission_payout_via_ach": "Pembayaran Komisen melalui ACH",
    "commission_payout_via_uWallet": "Pembayaran Komisen melalui UWallet",
    "commission_payout_via_payquicker": "Pembayaran Komisen melalui Payquicker",
    "withdraw_via_ach": "Mengeluarkan dana melalui ACH",
    "withdraw_via_payquicker": "Mengeluarkan dana melalui Payquicker",
    "credit_reversal": "Pembalikan Kredit",
    "load_fund_via_card_reversal": "Muatkan dana melalui pembalikan kad",
    "uwallet_funding_reversal": "Pembalikan pembiayaan Wallet U",
    "processing": "Memproses",
    "declined": "ditolak",
    "onHold": "Ditahan",
    "scheduled": "Dijadualkan",
    "cancelled": "Dibatalkan",
    "paymentCancelled": "Pembayaran telah dibatalkan",
    "beneficiaryName": "Nama Penerima",
    "b_b_code": "Kod Bank & Kod Cawangan",
    "validBankCode": "Sila masukkan kod yang sah",
    "minBankCode": "Kod tidak boleh kurang daripada 7 digit.",
    "load_fund_wallet": "Memuatkan dana dompet ",
    "ach_transfer": "Pemindahan bayaran ACH (Rumah Penjelasan Automatik) ",
    "mater_visa": "Mastercard/Visa",
    "go_to_transaction": "Transaksi seterusnya",
    "p2m_reversal": "Batalan pembayaran pedagang (P2M)",
    "deposit_account_list": "Senarai akaun deposit",
    "load_fund_via_ach_reversal": "Memuatkan dana melalui pemutaran ACH (ACH reversal）",
    "load_fund_via_connector_reversal": "Memuatkan dana melalui pemutaran Connector (Connector reversal)",
    "KYC_Failed": "Pengesahan KYC Gagal",
    "updateKYCText": "Adakah anda ingin mengemas kini Butiran KYC?",
    "updateWithdrawKYCText": "Sahkan identiti anda sebelum membuat pengeluaran",
    "userType": "Jenis pengguna",
    "usertypeErr": "Sila pilih Jenis Pengguna.",
    "recidencyNumberTxt": "Nombor Penduduk",
    "validResNum": "Nombor Penduduk Diperlukan",
    "validresidencyNum": "Sila masukkan nombor pemastautin yang sah",
    "flexText": "PayQuicker Flex",
    "flexTextVietnam": "Thanh toán linh hoạt",
    "withdrawalConfig": "Konfigurasi Pengeluaran",
    "withdrawalConfiguration": "Konfigurasi Pengeluaran",
    "addConfig": "Tambah Konfigurasi",
    "addFreequencyConfig": "Tambah/Edit Konfigurasi Kekerapan",
    "ReceivingAccount": "Akaun Penerimaan",
    "deactivateConfig": "Adakah anda ingin menyahaktifkan Konfigurasi yang dipilih?",
    "updateConfigSuccess": "Berjaya! kemas kini Config berjaya",
    "updateConfigFailed": "Gagal mengemas kini Config",
    "add_card_text": "Tambah Kad Kredit",
    "UWalletTransfer": "Pemindahan UWallet",
    "daily": 'Setiap hari',
    "weekly": "Setiap minggu",
    "monthly": "Bulanan",
    "biweekly": "Dua kali seminggu",
    "immediate": "serta merta",
    "percentage": "Peratusan",
    "percentError": "Sila masukkan peratusan yang sah",
    "toDistributor": "Kepada Pengedar",
    "distributorId": "Sila masukkan ID Pengedar",
    "invalidDistributor": "Sila masukkan Id Pengedar yang sah",
    "distributorNotFound": "Pengedar tidak ditemui",
    "distributorKYCError": "Pengedar Penerima tidak disahkan",
    "decimalNotPermit": "Tempat perpuluhan tidak dibenarkan",
    "paybyCard": "Bayar Dengan Kad",
    "validIDNum": "Sila masukkan nombor yang sah",
    "swiftCode": "Kod Swift",
    "validBankName": "Sila masukkan nama bank yang sah",
    "JAPANPAYOUT": "Bank",
    "idNumber": "Nombor ID",
    "commissionHistory": "Sejarah Suruhanjaya",
    "CITCON WITHDRAWAL": "Pengeluaran Bank",
    "validCityName": "Sila masukkan nama bandar yang sah",
    "pendingApproval": "Menunggu Kelulusan",
    "purposeCode": "Tujuan Pembayaran",
    "plsSeletpurposeCode": "Pilih tujuan pembayaran",
    "QualifyingCredit": "Kredit Layak",
    "tooltipAccountName": "Sila masukkan nama penuh anda, termasuk nama pertama dan nama keluarga (jika individu) cth John Smith ATAU nama penuh syarikat sah anda (jika syarikat) cth ABC Limited",
    "tooltipAccountNumber": "Masukkan nombor akaun bank",
    "tooltipBankCode": "Masukkan kod bank",
    "tooltipBranchCode": "Masukkan kod cawangan",
    "tooltipSwiftBic": "Sila masukkan SWIFT BIC (Kod Identiti Bank) bank anda yang boleh sama ada 8 atau 11 aksara panjangnya. Jika SWIFT BIC hanya 8 aksara, JANGAN isikan kepada 11 aksara dengan menambah XXX",
    "tooltipAddress": "Sila masukkan nombor/nama rumah kediaman anda (jika individu) atau berdaftar (jika syarikat) dan nama jalan cth 1 Jalan Utama",
    "tooltipCity": "Sila masukkan bandar atau bandar kediaman anda (jika individu) atau alamat berdaftar (jika syarikat) cth London",
    "tooltipZipcode": "Sila masukkan poskod/poskod kediaman anda (jika individu) atau alamat berdaftar (jika syarikat)",
    "tooltipCountry": "Sila pilih negara kediaman anda (jika individu) atau alamat berdaftar (jika syarikat).",
    "tooltipDOB": "Sila pilih tarikh lahir anda (jika individu sahaja)",
    "tooltipBankName": "Sila masukkan nama bank anda",
    "bankCode": "Kod bank",
    "branchCode": "Kod Cawangan",
    "dob": "Tarikh lahir",
    "selct_currency_deposit": "mata wang",
    "pc_from_text": "Daripada",
    "pc_to_text": "Kepada",
    "pc_amount_text": "Jumlah",
    "CNY PAYOUT": "Bank (WP)",
    "accountHolderaddress": "Alamat Pemegang Akaun",
    "accountHolderName": "Nama Pemilik Akaun",
    "branchName": "Nama cawangan",
    "continue": "Teruskan",
    "validBranchName": "Sila masukkan nama cawangan yang sah",
    "SOLU": "Pengeluaran Bank",
    "cardUpdatedSuccessfully": "Kad berjaya dikemas kini",
    "reason": "Sebab",
    "failedUpdateCard": "Gagal mengemas kini kad",
    "requiredError": "Ruangan Perlu Diisi",
    "kycNotVerified": "KYC tidak disahkan.",
    "VND PAYOUT": "tarik diri WP",
    "phoneNumberAliWP": "86 XXX XXXX XXXX",
    "phoneTooltip": "Sila berikan nombor telefon penerima (contoh: 86 XXX XXXX XXXX)",
    "emailTooltip": "Masukkan alamat emel penerima",
    "ALIPAY PAYOUT WP": "Alipay",

    "enterValidAccNameWithLimit": "Enter Valid Payee name with minimum 2 and maximum 70 characters",
    "enterValidAccNumWithLimit": "Enter Valid account number with minimum 4 and maximum 17 characters",
    "enterValidRoutingNumWithLimit": "Enter Valid routing number",
    "enterValidAddressWithLimit": "Enter Valid Address with minimum 2 and maximum 70 characters",
    "enterValidCityWithLimit": "Enter Valid City with minimum 2 and maximum 35 characters",
    "enterValidZipcodeWithLimit": "Enter Valid Zip code with minimum 2 and maximum 10 characters",
    "enterCitconValidAccNumWithLimit": "Enter Valid account number with minimum 4 and maximum 25 characters",
    "enterValidAccNameWithChinese": "Enter valid name in Chinese Characters",
    "enterValidBankNameWithChinese": "Enter valid Bank name in Chinese Characters",
    "enterValidBranchNameWithChinese": "Enter valid Branch name in Chinese Characters",
    "enterValidSoluAccNum": "Enter Valid numeric account number",
    "enterValidSoluAccNumWith20Limit": "Enter Valid numeric account number maximum 20 characters.",
    "enterValidSoluAccNumWith17Limit": "Enter Valid numeric account number maximum 17 characters.",
    "enterValidSoluPhoneNumWithLimit": "Enter Valid numeric phone number maximum 20 characters.",
    "enterValidSoluIDNumWithLimit": "Enter Valid alphanumeric ID number maximum 100 characters.",

    "enterValidAlipayPayeeNameWithLimit": "Enter Valid Payee name with minimum 2 and maximum 35 characters",
    "enterValidAlipayPhoneNumWithLimit": "Enter Valid numeric phone number with minimum = 5 maximum 34 characters.",
    "enterValidAlipayEmailWithLimit": "Enter Valid Email address  with minimum = 6 maximum 100 characters.",

    "enterValidThanhAccNameWithChinese": "Enter Valid  account name with minimum 1 and maximum 140 characters.",
    "enterValidThanhAccNumWithLimit": "Enter Valid  account number  with minimum 1 and maximum 30 characters.",
    "enterValidThanhSwiftCodeWithLimit": "Enter Valid swift code with minimum 8 and maximum 11 characters.",
    "enterValidThanhAddressWithLimit": "Enter Valid  address  with minimum 2 and maximum 35 characters.",

    "enterValidBeneficiaryNameWithLimit": "Enter valid name with maximum 20 characters.",
    "enterValidTWDAccNumWithLimit": "Enter valid account number with maximum 20 characters.",
    "enterValidTWDBranchCodeWithLimit": "Enter valid branch code with maximum 7 characters.",

    "enterValidMYRAccNameWithLimit": "Enter valid name with minimum = 2 and maximum 50 characters.",
    "enterValidMYRAccNumWithLimit": "Enter valid numeric account number with maximum 16 characters.",

    "enterValidTHBAccNameWithLimit": "Enter valid name with maximum 35 characters.",
    "enterValidTHBAccNumWithLimit": "Enter valid numeric account number  with  maximum 12 characters.",
    "enterValidTHBSwiftCodeWithLimit": "Enter valid swift code with maximum 11 characters.",
    "enterValidTHBAddressWithLimit": "Enter valid Address with minimum = 5 and maximum 35 characters.",
    "enterValidTHBCityWithLimit": "Enter valid city with maximum 60 characters.",
    "enterValidTHBZipcodeWithLimit": "Enter valid zip code with minimum = 5 and maximum 10 characters.",

    "enterValidGBPPayeeNameWithLimit": "Enter valid name with Minimum 3 and maximum 50 characters.",
    "enterValidGBPIbanWithLimit": "Enter valid Iban with maximum 34 characters.",
    "enterValidGBPBankNameWithLimit": "Enter valid Bank name with Minimum = 1 and maximum 50 characters.",

    "enterValidEURAccNameWithLimit": "Enter valid name with Minimum 1 and maximum 50 characters.",
    "enterValidEURAccNumWithLimit": "Enter valid numeric account number  with  Minimum 1 and maximum 35 characters.",
    "enterValidEURBankNameWithLimit": "Enter valid Bank name with Minimum = 2 and maximum 10 characters.",

    "enterValidJPYBankNameWithLimit": "Enter valid bank name with  maximum 35 characters.",
    "acceptTermsandconditions": "I followed the guide and set up my Alipay account to receive funds",
    "failedDuplicateCard": "Card addition failed as card already exist.",
    "updatedDate": "Updated Date",
    "noBankFound": "No Bank Found",
    "enterValidPhoneNumberWithLimit": "Enter Valid PhoneNumber with minimum 3 and maximum 35 characters",
    "branchNumber": "Branch Number",
    "bankNumber": "Bank Number",
    "validBankNumber": "Enter valid Bank number with maximum 4 characters.",
    "validBankNameWithLimit": "Enter valid Bank name with maximum 15 characters.",
    "validBranchNumber": "Enter valid Branch number with maximum 3 characters.",
    "validBranchNameWithLimit": "Enter valid Branch name with maximum 15 characters.",
    "selectAccountType": "Please select account type",
    "enterValidJPYAccNumWithLimit": "Enter valid numeric account number  with  Minimum 1 and maximum 7 characters.",
    "enterIntegerAmount": "Please enter a valid amount as an integer",
    "enterValidZenAccNameWithLimit": "Enter valid name with maximum 30 characters.",
    "zenginAccountNameHelperText": "Please enter the account holder name exactly as registered with the bank, using half-width katakana.",
    "weeklyProcessingNoticeText": "Weekly Processing Notice: Withdrawals using this account type are processed via a Zengin file generated once per week. Your transaction will remain pending until the next weekly processing. Funds typically arrive 1-3 business days after the file is generated.",
    "paybyJkoPay": "Pay by JKO Pay",
    "paybyAlipayHK": "Pay by Alipay HK",
    "paybyAlipay": "Pay by Alipay",
    "paybyUnionPay": "Pay by Union Pay",
    "addPaybyCard": "Add & Pay by Card",
    "address2": "Address2",
    "firstNameLocal": "Local First Name",
    "lastNameLocal": "Local Last Name",
    "paymentChannel": "Payment Channel",
    "paymentChannelErr": "Please select an Payment Channel.",
    "relationShip": "RelationShip",
    "validRelationShip": "Please enter valid relationship value",
    "payee": "penerima",
    "payeeTitle": "Gelaran",
    "validPayeeTitle": "Sila pilih gelaran.",
    "abaRoutingCode": "Kod Penghalaan ABA",
    "payeeTooltip": "penerima",
    "houseName": "Nombor/nama rumah dan nama jalan",
    "promptPay": "PromptPay",
    "bankTransferThailand": "Bank Transfer (Thailand)",
    "paymentInstrumentInUseAutoShipments": "Kami tidak dapat menyahdayakan/menghapus kad tersimpan ini daripada akaun uWallet anda kerana ia sedang digunakan oleh penghantaran auto aktif. Sila kemas kini kaedah pembayaran yang dikaitkan dengan penghantaran auto aktif terlebih dahulu sebelum mencuba semula. ID penghantaran auto tersebut adalah seperti berikut ",
    "paymentInstrumentInUseAutoShipmentsTwo": "Ini adalah penghantaran auto yang dikaitkan dengan kad ini ",
    "newTextTo": "Berapa banyak yang anda ingin pindahkan",
    "transferAmountDebit": "Jumlah keseluruhan didebitkan daripada",
    "transferAmountIn": "Jumlah keseluruhan dikreditkan ke dalam ",

    "EditBillingAddress": "Edit Alamat Bil",
    "BillingAddress": "Alamat Bil",
    "AddBillingAddress": "Tambah Alamat Bil",
    "billingAddress1": "Alamat Baris 1",
    "billingAddress2": "Alamat Baris 2",
    "billingAddress3": "Alamat Baris 3",
    "billingCity": "Bandar Bil",
    "billingState": "Negeri Bil",
    "billingZipcode": "Poskod Bil",
    "billingCountry": "Negara Bil",
    "validBillingAddress": "Sila masukkan Alamat Bil yang sah",
    "validBillingCity": "Sila masukkan Bandar Bil yang sah",
    "validBillingState": "Sila masukkan Negeri Bil yang sah",
    "validBillingZipcode": "Sila masukkan Poskod Bil yang sah",
    "validBillingCountry": "Sila pilih Negara Bil",
    "savedBillingAddress": "Alamat Bil Tersimpan",
    "billingInforText": "Anda boleh memilih alamat bil daripada senarai alamat tersimpan dan menggunakannya untuk kad anda.",
    "autoshipManagement": "Autoship Management",
    "autoshipReference": "Autoship Reference",
    "deactivateAutoship": "Do you want to deactivate selected Autoship?",
    "updateAutoshipSuccess": "Success! Autoship updated successfully",
    "updateAutoshipFailed": "Failed to update Autoship",
    "autoshipError": "Please select a payment instrument/connector for proceeding with the payment for subscriptions",
    "autoshipExternalId": "External ID",
    "paybyBankOrOnSite": "Pay by Bank or On-Site",
    "uwalletAmountCheckText": "Please enter valid UWallet amount",
    "uwalletFundAmountCheckText": "Please enter valid UWallet Funding amount",
    "paymentMethodErrorText": "Please select any payment method",
    "maintainanceNotice": "Your wallet has been updated. We’ve finished upgrading your wallet to use one primary currency for your account.",
    "maintainanceNotice_1": "You now see a single balance in your primary wallet currency instead of separate balances by currency.",
    "maintainanceNotice_2": "Any previous balances in other currencies were automatically converted into your primary wallet currency using a defined exchange rate.",
    "maintainanceNotice_3": "Your funds, transaction history, and payout schedule are all still intact and continue to work as before.",
    "contactSupport": "If something doesn’t look right or you have questions, please contact support and mention “wallet update”.",
    "txnAmount": "Transaction Amount",
    "cardHolderName": "Card Holder Name",
    "noBranchNumberFound": "No Branch Number Found",
    "payoutMethod": "Payout Method",
    "selectPayoutMethod": "Please select Payout Method",
    "accountDuplicateError": "The account is detected as a duplicate",
    "kycTextForBusiness": "You already have a verification in progress. Please wait for it to complete before submitting another.",
     "inpFnameChinese": "Por favor, introduzca un nombre válido en chino.",
    "inpLnameChinese": "Por favor, introduzca un apellido válido en chino.",
    "inpFnameEnglish": "Por favor, introduzca un nombre válido en inglés.",
    "inpLnameEnglish": "Por favor, introduzca un apellido válido en inglés.",
    "unionPayCard": "Tarjeta UnionPay",
    "verified": "Disahkan",
    "p2pLookupError": "Kami tidak dapat mengesahkan Distributor ID ini. Sila semak ID dan cuba lagi.",
    "p2pEnterReceiverInformation": "Masukkan Maklumat Penerima",
    "p2pDistributorId": "Distributor ID",
    "p2pDistributorTooltip": "“R” tidak diperlukan sebelum nombor distributor yang dimaksudkan.",
    "p2pEnterDistributorId": "Masukkan Distributor ID",
    "p2pReceiverNameAsPerRecords": "Nama Penerima (mengikut rekod kami)",
    "p2pVerifyingReceiver": "Mengesahkan penerima...",
    "p2pVerifyAfterDistributorId": "Kami akan mengesahkan penerima selepas anda memasukkan Distributor ID yang sah.",
    "p2pReceiverNameLabel": "Nama Penerima",
    "p2pEnterReceiverName": "Masukkan nama penerima",
    "p2pVerifyReceiverDistributorFirst": "Sahkan Distributor ID penerima terlebih dahulu.",
    "p2pReceiverNameMismatch": "Nama penerima tidak sepadan dengan rekod kami.",
    "p2pReceiverNameMatch": "Nama penerima sepadan dengan rekod kami.",
    "p2pEnterReceiverNameAsPerRecords": "Masukkan Nama Penerima seperti dalam rekod kami",
    "p2pReceiverNameHelpText": "Sila pastikan nama di atas sepadan dengan penerima yang anda ingin hantar wang.",
    "p2pConfirmDistributorIdStep": "Sahkan Distributor ID",
    "p2pReenterDistributorIdHelp": "Sila masukkan semula Distributor ID (salin & tampal dinyahdayakan)",
    "p2pCopyPasteDisabled": "Salin dan tampal dinyahdayakan.",
    "p2pConfirmDistributorIdLabel": "Sahkan Distributor ID",
    "p2pReenterDistributorId": "Masukkan semula Distributor ID",
    "p2pDistributorIdsMustMatch": "Distributor ID tidak sepadan. Sila semak dan cuba lagi.",
    "p2pEnterTransferDetails": "Masukkan Butiran Pemindahan",
    "p2pWhyTheseSteps": "Mengapa langkah ini?",
    "p2pWhyTheseStepsLine1": "Pengesahan nama membantu memastikan anda menghantar kepada penerima yang betul.",
    "p2pWhyTheseStepsLine2": "Memasukkan semula Distributor ID mengurangkan ralat dan mengelakkan pemindahan tidak sengaja.",
    "p2pWhyTheseStepsLine3": "Keselamatan anda adalah keutamaan kami.",
    "p2pPrivacyNote": "Nama tengah penerima disembunyikan untuk melindungi privasi.",
    "p2pMonthlyLimitNote": "Had bulanan Peer to Peer ialah",
    "p2pMaxMonthlyLimitNote": "Had bulanan maksimum ialah",
    "p2pFeeNote": "Yuran Peer to Peer sebanyak",
    "p2pFeeNoteSuffix": "akan dikenakan."
}
